import {FilesViewer} from '@/components/FilesViewer';

/*
    Every feature should have its own entry component. We will call that component a page.
*/
export const FilesViewerPage = () => {
    return <FilesViewer />;
};
